import React from 'react';
import Button from '../components/common/Button';
import printQueueService from '../services/api/printQueue';
import Row from '../components/printQueue/row';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AdminTableSection, AdminTableContent } from 'src/assets/styles/components/AdminTable';

const PrintQueueTable = (props) => {
  const [printQueue, set_printQueue] = React.useState([{ GLs: [{}] }]);
  const [loaded, set_loaded] = React.useState(false);

  React.useEffect(() => {
    getprintQueue();
  }, []);

  function getprintQueue() {
    set_loaded(false);
    printQueueService
      .getPrintQueue()
      .then((response) => {
        if (response.data.success) {
          set_loaded(true);
          set_printQueue(response.data.printQueue);
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loaded(false);
      });
  }

  function updateAPrintQueue(identification) {
    printQueueService
      .updateAPrintQueue(identification)
      .then((response) => {
        if (response.data.success) {
          getprintQueue();
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loaded(false);
      });
  }

  return (
    <AdminTableSection>
      <AdminTableContent>
        <Button text={'Recargar'} onClick={() => getprintQueue()} />
      </AdminTableContent>
      {loaded ? (
        <div>
          <h2>Cola de Impresión</h2>
          <table>
            <thead>
              <tr>
                <th>Cédula</th>
                <th>Nombre</th>
                <th>Creado</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {printQueue.length ? (
                printQueue.map((element) => (
                  <Row
                    printQueue={element}
                    deleteOfQueue={updateAPrintQueue}
                    history={props.history}
                  />
                ))
              ) : (
                <p>No hay elementos para imprimir</p>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Cargando</p>
      )}
    </AdminTableSection>
  );
};

export default PrintQueueTable;
